import { type Nullable } from '@silverhand/essentials';
import { useState, useCallback } from 'react';

import styles from './index.module.scss';

type ScopeGroupProps = {
  readonly groupName: string;
  readonly isAutoExpand?: boolean;
  readonly scopes: Array<{
    id: string;
    name: string;
    description?: Nullable<string>; // Organization scope description cloud be `null`
  }>;
};

const ScopeGroup = ({ groupName, scopes, isAutoExpand = false }: ScopeGroupProps) => {
  const [expanded, setExpanded] = useState(isAutoExpand);

  const toggle = useCallback(() => {
    setExpanded((previous) => !previous);
  }, []);

  return (
    <div className={styles.scopeGroupUp}>
      <ul className={styles.scopesList}>
        {scopes.map(({ id, name, description }) => (
          <li key={id} className={styles.scopeItem}>
            <svg
              className={styles.checkIcon}
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 4L13 3L6 11L3 8L2 9L6 13L14 4Z" fill="currentColor" />
            </svg>
            <span>{description ?? name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScopeGroup;
